import { Button, useMediaQuery, TextField, DialogActions, DialogContent } from '@mui/material';
import { useEffect, useState, useRef, useContext } from 'react';
import DialogBox from '../ajax/DialogBox'
import { toast } from 'react-toastify';
import { callPostApi } from '../../function/ApiCallFunction';
import GradientLoader from '../CommanComponents/GradientLoader';
import { DataContext } from '../../context/DataContext';
import { indiaDayKey } from '../../include/indiaDate';


export default function LoadQRCode({idsss, onSuccess, apiRef}) 
{ 

    const {loginData } = useContext(DataContext);
    const store_id = loginData?.store_info?.store_id;

  const isMobile = useMediaQuery('(max-width:768px)');
  const [loading, setLoading] = useState(false);
  const inputRef1 = useRef();
  const [errors, setErrors] = useState({});
  const [open, setOpen] = useState(false);

  const getMinExpiryDate = () => {
   return indiaDayKey();
  };

  const [activedate, setActivedate] = useState(getMinExpiryDate());
 
  const validate = () => {
    const newErrors = {};
    if (!activedate ) { newErrors.activedate= 'Enter Activate Date'; }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleOk = () => {
     if (!validate()) return;  
     activeQRApi()
  }
 
  // Active QR APi
  const activeQRApi= async () => {
    try {
      setLoading(true);
      const selectedIds = Array.from(apiRef.current.getSelectedRows().keys());
      const payload = { mod: "ACTIVE_CASHI_QECODE", data_arr: { store_id ,active_date:activedate, tagLotId:selectedIds} };
      const apiResult = await callPostApi("cashi-qrcode", payload);
      
      if (apiResult.status === "200") {
         toast.success(apiResult.data);
         if (onSuccess && typeof onSuccess === 'function') { try { await onSuccess(); } catch (e) { } }
         window.dispatchEvent(new CustomEvent('refreshQRCodeList', { detail: { status: 'pending' } }));
         setOpen(false);
        } else { toast.info(apiResult.status_message); }
        } catch (err) { toast.info(err); } 
         finally { setLoading(false); }
  }; 

  const opendataactivate = () => {
    const selectedIds = Array.from(apiRef.current.getSelectedRows().keys());
    if(selectedIds.length === 0){ toast.info("Please Select any QR from list!") }
    else{ setOpen(true) }
  }

    useEffect(() => {                          
    if (!open) { setActivedate(getMinExpiryDate()); setErrors({}); } 
    }, [open]);

    useEffect(() => 
    {
      if (isMobile && apiRef.current) {
        apiRef.current.autosizeColumns({ includeHeaders: true });
      }
   }, [isMobile,apiRef]);
 

  return (
    <>
   
      {/* Title */}
       <Button variant="contained" sx={{ background:'linear-gradient(195deg, #66BB6A, #43A047)', color: '#ffffff',ml:1}}
          onClick={() => opendataactivate()} > Activate </Button>
    
       <DialogBox open={open} onClose={() => setOpen(false)} title="Activate QR Code">
         <DialogContent>

          <TextField sx={{mt:2}} fullWidth type="date"  label="Activate Date" InputLabelProps={{ shrink: true }}
              value={activedate}  error={!!errors.activedate}  helperText={errors.activedate} inputRef={inputRef1}
              onChange={(e) => { setActivedate(e.target.value); setErrors(prev => ({ ...prev, activedate: undefined })); }}
              onKeyDown={(e) => e.preventDefault()}
               inputProps={{ min: getMinExpiryDate(),}}
              onClick={() => { if (inputRef1.current && typeof inputRef1.current.showPicker) 
              { inputRef1.current.showPicker(); } }} />
           </DialogContent>
         
          <DialogActions>
              <Button onClick={() => setOpen(false)} color="primary"> Cancel </Button>
              <Button onClick={() =>  handleOk()} color="primary" variant="contained"> Ok </Button>
          </DialogActions>
       </DialogBox>
       
         {loading && <GradientLoader text="Loading" />}  {/* Loader */}
    </>
  );
}
